const META_PIXEL_SCRIPT_URL = 'https://connect.facebook.net/en_US/fbevents.js';

// EACH PRODUCT HAS ITS OWN PIXEL ON ITS OWN DOMAIN. KEYING THEM BY HOSTNAME
// MEANS A PIXEL CAN NEVER LAND ON THE OTHER PRODUCT'S SITE, AND DEV, TESTING
// AND STAGING BUILDS NEVER SEND TO THE PRODUCTION PIXELS
const META_PIXEL_IDS: Record<string, string> = {
  'app.pharmaplan.ca': '2905501926461242',
  'app.pharmagap.com': '2110820939807109',
};

type MetaPixelCommand = Array<unknown>;

interface IMetaPixel {
  (...args: MetaPixelCommand): void;
  callMethod?: (...args: MetaPixelCommand) => void;
  queue: Array<MetaPixelCommand>;
  push: IMetaPixel;
  loaded: boolean;
  version: string;
}

declare global {
  interface Window {
    fbq?: IMetaPixel;
    _fbq?: IMetaPixel;
  }
}

let metaPixel: IMetaPixel | null = null;

// SAME STUB AS META'S BASE CODE: CALLS MADE BEFORE fbevents.js HAS LOADED ARE
// QUEUED AND REPLAYED BY THE SCRIPT
const createMetaPixelQueue = (): IMetaPixel => {
  const fbq = ((...args: MetaPixelCommand) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }

    fbq.queue.push(args);
  }) as IMetaPixel;

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  return fbq;
};

// THE PIXEL ONLY LOADS ONCE COOKIES ARE ACCEPTED
export const loadMetaPixel = () => {
  const pixelId = META_PIXEL_IDS[window.location.hostname] ?? null;
  if (pixelId === null || metaPixel !== null) return;

  metaPixel = createMetaPixelQueue();
  window.fbq = metaPixel;
  // eslint-disable-next-line no-underscore-dangle -- _fbq IS THE GLOBAL NAME META'S SCRIPT READS
  window._fbq = window._fbq ?? metaPixel;

  const script = document.createElement('script');
  script.async = true;
  script.src = META_PIXEL_SCRIPT_URL;
  document.head.appendChild(script);

  metaPixel('init', pixelId);
};

// NOTHING IS SENT UNTIL THE PIXEL HAS LOADED
export const trackMetaPageView = () => {
  metaPixel?.('track', 'PageView');
};
